/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @param str
 * @returns a capitalize string ex: 'HELLO_WORLD' => 'Hello World'
 */
export const capitalize = (str: string): string => {
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
/**
 * @param error
 * @returns  a string error from response
 */
export const getResError = (error?: any) => {
  if (!error) return "Something Went Wrong";
  const isNetError = error?.message?.includes("Network Error");
  if (isNetError) return "Network Error";
  
  // Handle account locked error (HTTP 423)
  if (error?.response?.status === 423) {
    if (error?.response?.data?.errors && Array.isArray(error.response.data.errors)) {
      return error.response.data.errors.join(", ");
    }
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }
    return "Account is temporarily locked due to multiple failed login attempts. Please try again later or contact an administrator.";
  }
  
  if (error?.response?.data?.data) {
    // Join the error messages into a single string
    return error.response.data.data.join(", ");
  }
  if (error?.response?.data?.message) {
    return error?.response?.data?.message;
  }

  return (
    error?.response?.data?.error ?? error?.message ?? "Something Went Wrong"
  );
};

/**
 * Convert image file to base64 string
 * @param file
 * @returns a promise that resolves with the base64 string (if not errors occured)
 */
export const imageFileToBase64 = (file: File): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};
